import { WIDGET_SHAPE_TYPE } from "@ever-tutor/et-widgets/tldraw";
import { Box } from "tldraw";
import {
  convertTldrawShapeToBlurryShape,
  convertTldrawIdToSimpleId,
} from "../../shared/format/convertTldrawShapeToBlurryShape";
import { BlurryShapesPart } from "../../shared/types/PromptPart";
import { AgentRequest } from "../../shared/types/AgentRequest";
import { AgentHelpers } from "../AgentHelpers";
import { PromptPartUtil, registerPromptPartUtil } from "./PromptPartUtil";

export const BlurryShapesPartUtil = registerPromptPartUtil(
  class BlurryShapesPartUtil extends PromptPartUtil<BlurryShapesPart> {
    static override type = "blurryShapes" as const;

    override getPart(
      request: AgentRequest,
      helpers: AgentHelpers,
    ): BlurryShapesPart {
      const { editor } = this;

      const shapes = editor
        .getCurrentPageShapesSorted()
        .filter((shape) => shape.type !== WIDGET_SHAPE_TYPE);
      const contextBoundsBox = Box.From(request.bounds);

      // Get all shapes within the agent's viewport
      const shapesInBounds = shapes.filter((shape) => {
        const bounds = editor.getShapeMaskedPageBounds(shape);
        if (!bounds) return false;
        return contextBoundsBox.includes(bounds);
      });

      // Convert the shapes to the blurry shape format
      const blurryShapes = shapesInBounds
        .map((shape) => convertTldrawShapeToBlurryShape(editor, shape))
        .filter((s) => s !== null);

      const normalizedBlurryShapes = blurryShapes.map((shape) => {
        const bounds = helpers.roundBox(shape);
        return { ...shape, x: bounds.x, y: bounds.y, w: bounds.w, h: bounds.h };
      });
      const reportedIds = new Set(
        normalizedBlurryShapes.map((shape) => shape.shapeId),
      );
      const studentEdits = [
        ...helpers.getStudentEdits(
          shapesInBounds.filter((shape) =>
            reportedIds.has(convertTldrawIdToSimpleId(shape.id)),
          ),
        ),
      ];

      return {
        type: "blurryShapes",
        shapes: normalizedBlurryShapes,
        studentEditedShapeIds: studentEdits.map(([id]) =>
          convertTldrawIdToSimpleId(id),
        ),
        studentEditVersions: Object.fromEntries(
          studentEdits.map(([id, version]) => [
            convertTldrawIdToSimpleId(id),
            version,
          ]),
        ),
      };
    }
  },
);
